import { PLATFORM_REPORTS_READ } from '../operations/dashboard.operations.js';
import { FEATURE_KEYS, MODULE_KEYS, ROUTE_IDS } from './routes/ids.js';
const tk = (value) => value;
const operation = (value) => value;
const formId = (value) => value;
const fieldId = (value) => value;
const queryId = (value) => value;
const telemetry = (value) => value;
export const PLATFORM_INSTRUMENT_INVENTORY_REPORT_ID = 'report.platform.instrument-inventory';
export const PLATFORM_INSTRUMENT_INVENTORY_REPORT_TYPE = 'PLATFORM_INSTRUMENT_INVENTORY';
export const PLATFORM_INSTRUMENT_INVENTORY_FORM_ID = 'form.reports.platformInstrumentInventory';
const statusField = {
    id: fieldId('field.reports.platformInstrumentInventory.status'),
    name: 'status',
    labelKey: tk('reports.platformInstrumentInventory.parameters.status'),
    fieldType: 'select',
    options: [
        { value: 'ACTIVE', labelKey: tk('reports.platformInstrumentInventory.status.active') },
        { value: 'INACTIVE', labelKey: tk('reports.platformInstrumentInventory.status.inactive') },
        { value: 'SUSPENDED', labelKey: tk('reports.platformInstrumentInventory.status.suspended') },
        { value: 'DELISTED', labelKey: tk('reports.platformInstrumentInventory.status.delisted') },
    ],
    layout: { xs: 12, sm: 6, md: 4 },
    value: {
        submitBehavior: 'include',
        hiddenValuePolicy: 'unregister',
    },
};
export const PLATFORM_INSTRUMENT_INVENTORY_FORM = {
    id: formId(PLATFORM_INSTRUMENT_INVENTORY_FORM_ID),
    schemaVersion: 1,
    module: MODULE_KEYS.REPORTS,
    feature: FEATURE_KEYS.REPORTS_VIEW,
    operationId: operation(PLATFORM_REPORTS_READ),
    privacyClassification: 'INTERNAL',
    telemetryId: telemetry('experience.form.reports.platformInstrumentInventory'),
    accessibilityLabelKey: tk('reports.platformInstrumentInventory.parameters.accessibilityLabel'),
    availability: 'AVAILABLE',
    owner: 'platform-reference-data',
    titleKey: tk('reports.platformInstrumentInventory.parameters.title'),
    descriptionKey: tk('reports.platformInstrumentInventory.parameters.description'),
    mode: 'create',
    fields: [statusField],
    actions: [],
    submission: {
        includeFields: [statusField.id],
    },
};
function column(id, field, labelKey, fieldType) {
    return {
        id: id,
        schemaVersion: 1,
        module: MODULE_KEYS.REPORTS,
        feature: FEATURE_KEYS.REPORTS_VIEW,
        operationId: operation(PLATFORM_REPORTS_READ),
        privacyClassification: 'INTERNAL',
        telemetryId: telemetry(`experience.${id}`),
        accessibilityLabelKey: tk(labelKey),
        availability: 'AVAILABLE',
        owner: 'platform-reference-data',
        labelKey: tk(labelKey),
        field,
        fieldType,
        defaultVisible: true,
        hideable: true,
    };
}
const columns = [
    column('column.report.platformInstrument.symbol', 'symbol', 'reports.platformInstrumentInventory.columns.symbol', 'text'),
    column('column.report.platformInstrument.name', 'instrumentName', 'reports.platformInstrumentInventory.columns.name', 'text'),
    column('column.report.platformInstrument.isin', 'isin', 'reports.platformInstrumentInventory.columns.isin', 'text'),
    column('column.report.platformInstrument.exchange', 'exchange', 'reports.platformInstrumentInventory.columns.exchange', 'text'),
    column('column.report.platformInstrument.sector', 'sector', 'reports.platformInstrumentInventory.columns.sector', 'text'),
    column('column.report.platformInstrument.type', 'instrumentType', 'reports.platformInstrumentInventory.columns.type', 'text'),
    column('column.report.platformInstrument.currency', 'currency', 'reports.platformInstrumentInventory.columns.currency', 'text'),
    column('column.report.platformInstrument.status', 'status', 'reports.platformInstrumentInventory.columns.status', 'status'),
    column('column.report.platformInstrument.marketDataCount', 'marketDataCount', 'reports.platformInstrumentInventory.columns.marketDataCount', 'number'),
    column('column.report.platformInstrument.latestPriceDate', 'latestPriceDate', 'reports.platformInstrumentInventory.columns.latestPriceDate', 'date'),
    column('column.report.platformInstrument.updatedAt', 'updatedAt', 'reports.platformInstrumentInventory.columns.updatedAt', 'datetime'),
];
export const PLATFORM_INSTRUMENT_INVENTORY_REPORT = {
    id: PLATFORM_INSTRUMENT_INVENTORY_REPORT_ID,
    schemaVersion: 1,
    module: MODULE_KEYS.REPORTS,
    feature: FEATURE_KEYS.REPORTS_VIEW,
    operationId: operation(PLATFORM_REPORTS_READ),
    privacyClassification: 'INTERNAL',
    telemetryId: telemetry('experience.report.platform.instrumentInventory'),
    accessibilityLabelKey: tk('reports.platformInstrumentInventory.title'),
    availability: 'AVAILABLE',
    owner: 'platform-reference-data',
    reportType: PLATFORM_INSTRUMENT_INVENTORY_REPORT_TYPE,
    titleKey: tk('reports.platformInstrumentInventory.title'),
    descriptionKey: tk('reports.platformInstrumentInventory.description'),
    category: 'MANAGEMENT',
    scope: 'PLATFORM',
    routeId: ROUTE_IDS.REPORTS,
    dataSourceId: queryId('query.reports.platformInstrumentInventory'),
    parameterFormId: PLATFORM_INSTRUMENT_INVENTORY_FORM_ID,
    runFormId: PLATFORM_INSTRUMENT_INVENTORY_FORM_ID,
    rowIdField: 'symbol',
    columns,
    formats: ['json'],
    allowedFormats: ['json'],
    generatorId: 'live.generator.platformInstrumentInventory',
    executionMode: 'LIVE_QUERY',
    liveQueryPolicy: Object.freeze({
        cache: 'NO_STORE',
        refresh: 'ON_DEMAND',
        synchronousExportMaxRows: 10_000,
    }),
    operationBindings: {
        listOperationId: PLATFORM_REPORTS_READ,
        runOperationId: PLATFORM_REPORTS_READ,
    },
    lineage: {
        sourceSystem: 'platform-instrument-master',
        sourceEntities: ['Instrument', 'MarketData'],
        calculationVersion: 'platform-instrument-inventory-v1',
    },
    authoritativeMetadataPolicy: {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'REFERENCE_DATA',
        requireLineage: true,
        requireFreshness: true,
        requireRestatementState: false,
        requireRuleVersions: false,
        requirePartialDataIndicator: true,
    },
    implemented: true,
    auditPolicy: 'ALWAYS',
};
export const PLATFORM_REPORT_DASHBOARD_FORMS = Object.freeze({
    [PLATFORM_INSTRUMENT_INVENTORY_FORM.id]: PLATFORM_INSTRUMENT_INVENTORY_FORM,
});
export const PLATFORM_REPORT_REGISTRY = Object.freeze({
    [PLATFORM_INSTRUMENT_INVENTORY_REPORT.id]: PLATFORM_INSTRUMENT_INVENTORY_REPORT,
});
